"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Button = void 0;
var _react = _interopRequireWildcard(require("react"));
var _CssClassNames = _interopRequireDefault(require("../../scss/CssClassNames"));
var _stylesModule = _interopRequireDefault(require("./styles.module.scss"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var classNameFnc = new _CssClassNames["default"](_stylesModule["default"], ['utility', 'text']).className;
var Button = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var _ref$Tag = _ref.Tag,
    Tag = _ref$Tag === void 0 ? 'a' : _ref$Tag,
    children = _ref.children,
    _ref$isSubmit = _ref.isSubmit,
    isSubmit = _ref$isSubmit === void 0 ? false : _ref$isSubmit,
    size = _ref.size,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? null : _ref$type,
    _ref$block = _ref.block,
    block = _ref$block === void 0 ? false : _ref$block,
    _ref$shadow = _ref.shadow,
    shadow = _ref$shadow === void 0 ? true : _ref$shadow,
    _ref$extraAttributes = _ref.extraAttributes,
    extraAttributes = _ref$extraAttributes === void 0 ? {} : _ref$extraAttributes,
    _ref$events = _ref.events,
    events = _ref$events === void 0 ? {} : _ref$events,
    _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === void 0 ? null : _ref$onClick,
    _ref$onFocus = _ref.onFocus,
    onFocus = _ref$onFocus === void 0 ? null : _ref$onFocus,
    _ref$href = _ref.href,
    href = _ref$href === void 0 ? '#' : _ref$href,
    _ref$target = _ref.target,
    target = _ref$target === void 0 ? '_self' : _ref$target,
    _ref$isGatsby = _ref.isGatsby,
    isGatsby = _ref$isGatsby === void 0 ? false : _ref$isGatsby,
    _ref$tabIndex = _ref.tabIndex,
    tabIndex = _ref$tabIndex === void 0 ? null : _ref$tabIndex,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    className = _ref.className;
  var classes = "\n        btn ".concat(type ? "btn-".concat(type) : '', "\n        ").concat(size ? "btn-".concat(size) : '', " \n        ").concat(block ? 'btn-block' : '', "\n        ").concat(type === 'primary' && shadow && (!extraAttributes || !extraAttributes.disabled) ? 'with-shadow' : '', "\n        ").concat(className ? className : '', " \n    ");
  return isGatsby ? /*#__PURE__*/_react["default"].createElement(Tag, _extends({}, classNameFnc(classes), {
    ref: ref,
    to: href
  }, tabIndex !== null && {
    tabIndex: tabIndex
  }, onClick && {
    onClick: onClick
  }, onFocus && {
    onFocus: onFocus
  }, extraAttributes), children) : /*#__PURE__*/_react["default"].createElement(Tag, _extends({}, classNameFnc(classes), {
    ref: ref
  }, onClick && {
    onClick: onClick
  }, onFocus && {
    onFocus: onFocus
  }, !isSubmit && {
    href: href,
    target: target
  }, isSubmit && {
    type: 'submit'
  }, tabIndex !== null && {
    tabIndex: tabIndex
  }, disabled && {
    disabled: true
  }, extraAttributes, events), children);
});
exports.Button = Button;